import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useABTestAYOBasBanner = () => {
  const {isActive, activateAbTest} = useIsFeatureActive('ay_outlet_bas_banner');

  const isAYOBasBanner = (path?: string) => {
    return path && path.includes('aboutyou-outlet.');
  };

  // to get rid of prop drilling we stick to the process.env.STACK here
  // since the ab test activation name is different based on the stack (desktop / mWeb)
  const activateABTestAYOBasBanner = () => {
    activateAbTest(process.env.STACK === 'desktop' ? 'ab_oba_d' : 'ab_oba_m');
  };

  return {
    shouldHideBasBanner: isActive,
    activateABTestAYOBasBanner,
    isAYOBasBanner,
  };
};
